import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import LogoOnLight from "scmp-app/components/plus/plus-logo/logo-on-light.svg";

export const StyledPlusLogo = styled(LogoOnLight)`
  inline-size: auto;
  block-size: 32px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100vw;
  block-size: calc(100vh - 24px);

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;

  max-inline-size: 280px;
`;

export const IntroText = styled.div`
  color: #333333;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%;
  text-align: center;
`;

export const DownloadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

export const DownloadIconContainer = styled.div`
  display: flex;
  gap: var(--12, 12px);
  justify-content: center;
  align-items: flex-start;
`;

export const DownloadText = styled.div`
  color: #000000;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
`;

export const Divider = styled.div`
  inline-size: 100%;
  block-size: 1px;

  background: #000000;
`;

export const SubscriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

export const SubscriptionText = styled.div`
  color: #333333;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%; /* 20.8px */
  text-align: center;
`;

export const SubscriptionLink = styled(BaseLink)`
  color: #4585ff;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%;
  text-align: center;
  text-decoration-line: underline;
`;
